import TooltipForm from '../TooltipForm';
import { Container, Row, Col } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import CustomStylesClass from './CustomStyles';
import BrowserDefaultsClass from './BrowserDefaults';
import SupportedElementsClass from './SupportedElements';

const FormValidation = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Validation Forms' parent='Forms Controls' title='Validation Forms' />
      <Row>
        <Col sm='12'>
          <CustomStylesClass />
          <BrowserDefaultsClass />
          <SupportedElementsClass />
          <TooltipForm />
        </Col>
      </Row>
    </Container>
  );
};

export default FormValidation;
